import React, { Fragment, useEffect, useState } from 'react'
import config from '../../config'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useNavigate, useParams } from 'react-router-dom'
import { useForm, Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import { yupResolver } from '@hookform/resolvers/yup';
import { GetAreas, GetPropertyTypes, AddProperty, AddImages, RemoveImages, HeaderImage, GetProperty, AddDocument, AddRemark, UpdatePropertyStatus } from '../../REST/properties'
import * as yup from "yup";
import PropertyEditView from './edit';
import Documents from '../Utilities/documents';
import Remarks from '../Utilities/remarks';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { GetAgreementById } from '../../REST/agreements';
//import { GetCompanyById } from '../../REST/company';
import Typography from '@mui/material/Typography';
import LeaseHistory from '../Agreements/leaseHistory';
import BackIcon from '@mui/icons-material/ArrowBack';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SaveIcon from '@mui/icons-material/Save';
import ArticleIcon from '@mui/icons-material/Article';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { handleErr } from '../../helpers/errors';
import DefaultSettings from '../../Utils/settings';
import LeaseListing from '../WaitList/leasing';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Action from '../../themes/components/Action';
import Form from '../../themes/components/Form';
import FormActions from '../../themes/components/FormActions';

export default function DataGridDemo() {

    const navigate = useNavigate()
    const handleEditLink = (id) => navigate('/properties/listings/' + id + '/edit')

    return (
        <PageShell>
            <PageHeader
                title="Property Listings"
                back
                onBack={() => navigate('/')}
                actions={
                    <Action
                        primary
                        icon={<AddCircleIcon />}
                        label="Add Property"
                        onClick={() => navigate('/properties/listings/add')}
                    />
                }
            />
            <PageContent fill>
                <LeaseListing internal={true} edit={handleEditLink} />
            </PageContent>
        </PageShell>
    );
}

export function AddListing() {
    const [area, setArea] = useState([])
    const [type, setType] = useState([])
    const navigate = useNavigate()

    const schema = yup.object({
        name: yup.string().trim().required(),
        description: yup.string().trim().required(),
        area: yup.string().trim(),
        rent: yup.number().required(),
        propertyType: yup.string().trim().required(),
        address: yup.string().trim().required()
    })

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: '',
            description: '',
            rent: '',
            address: '',
            area: '',
            propertyType: ''
        }
    });
    const { control, setError, formState: { errors }, clearErrors, reset } = methods;

    console.log('errors', errors)
    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    useEffect(() => {
        (async () => {
            const areas = await GetAreas()
            const types = await GetPropertyTypes()
            setArea(x => areas.data)
            setType(y => types.data)
        })()

        clearErrors()
        reset()
    }, [clearErrors, reset])

    const onSubmit = async (data) => {
        console.log(data)
        const result = { ...data, location: { type: 'Point', coordinates: [33.6346, -116.1658] } }
        const resp = await AddProperty(result).catch((err) => {
            handleErr(err, setError)
        })
        if (resp) navigate('/properties/listings')
    }

    const getOptions = (opts = []) => {
        return [<option key='select'>Select One</option>].concat(opts.map((e, idx) => {
            return <option key={idx} value={e._id}>{e.name}</option>
        }))
    }

    return (
        <PageShell>
            <PageHeader
                title="Add Property"
                back
                onBack={() => navigate(-1)}
            />
            <PageContent>
                <Form methods={methods} onSubmit={onSubmit}>
                    <Controller name="name" control={control} render={({ field }) => <TextField variant='standard' margin='dense' required error={isError(errors.name)} helperText={errors.name && errors.name.message} fullWidth label='Name' {...field} />} />
                    <Controller name="description" control={control} render={({ field }) => <TextField variant='standard' margin='dense' required error={isError(errors.description)} helperText={errors.description && errors.description.message} fullWidth label='Description' {...field} />} />
                    <Controller name="area" control={control} render={({ field }) => <FormControl error={isError(errors.area)} variant='standard' margin='dense' fullWidth><InputLabel>Building #</InputLabel><NativeSelect {...field} >{getOptions(area)}</NativeSelect>{errors.area && <FormHelperText>{errors.area.message}</FormHelperText>}</FormControl>} />
                    <Controller name="rent" control={control} render={({ field }) => <TextField variant='standard' margin='dense' required error={isError(errors.rent)} helperText={errors.rent && errors.rent.message} fullWidth label='Rental Amount' type='number' {...field} />} />
                    <Controller name="propertyType" control={control} render={({ field }) => <FormControl error={isError(errors.propertyType)} variant='standard' margin='dense' required fullWidth><InputLabel>Property Type</InputLabel><NativeSelect {...field}>{getOptions(type)}</NativeSelect>{errors.propertyType && <FormHelperText>{errors.propertyType.message}</FormHelperText>}</FormControl>} />
                    <Controller name="address" control={control} render={({ field }) => <TextField variant='standard' margin='dense' required error={isError(errors.address)} helperText={errors.address && errors.address.message} fullWidth label='Address' {...field} />} />
                    <FormActions>
                        <Button type="submit" variant='outlined' startIcon={<SaveIcon />}>Save</Button>
                    </FormActions>
                </Form>
            </PageContent>
        </PageShell>
    )
}

export function EditListing() {
    const { id } = useParams()
    const [data, setData] = useState({ images: [], documents: [] })
    const [refresh, setRefresh] = useState(false)
    const [agreement, setAgreement] = useState({})
    const navigate = useNavigate()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const propertyEditRef = React.useRef(null)

    const toggleRefresh = () => setRefresh(r => !r)

    useEffect(() => {
        (async () => {
            const result = await GetProperty(id)
            const { data } = result
            const { tenants, status } = data
            if (status === 'Leased' && tenants && tenants.length > 0) {
                const currentTenant = tenants[tenants.length - 1]
                const { agreementId } = currentTenant
                const res = await GetAgreementById(agreementId)
                setAgreement(res.data)
            }
            setData(data)
        })()
    }, [id, refresh])

    const addDocument = (doc) => AddDocument(id, doc).then(toggleRefresh)
    const addRemark = (doc) => AddRemark(id, doc).then(toggleRefresh)
    const handleStatus = (status) => { UpdatePropertyStatus(id, { status }).then(toggleRefresh) }
    const handleSave = () => { /* Save logic handled by PropertyEditView */ }

    return (
        <PageShell>
            <PageHeader title="Edit Property" back onBack={() => navigate(-1)} />
            <PageContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <PropertyEditView listing={data} onRefresh={toggleRefresh} hideSaveButton={true} submitRef={propertyEditRef} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <HeaderImageView listing={data} onRefresh={toggleRefresh} />
                        <OtherImageView listing={data} onRefresh={toggleRefresh} />
                        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                            <Documents docIds={data.documents} onUpload={res => addDocument(res._id)} module="Property" />
                            <Remarks docIds={data.remarks} onUpload={res => addRemark(res._id)} fullWidth={true} module="Property" />
                        </Stack>
                        <div className='mt-4'>
                            <Typography variant="h6" sx={{ mb: 1 }}>Lease Info</Typography>
                            <Divider sx={{ mb: 1 }} />
                            {data.status === 'Leased' ? (
                                <Fragment>
                                    <Typography variant="body2" gutterBottom>Account: {agreement.title}</Typography>
                                    <Typography variant="body2" gutterBottom>Account Number#: {agreement.agreementNum}</Typography>
                                </Fragment>
                            ) : (
                                <Typography variant="body2" gutterBottom>Status: {data.status}</Typography>
                            )}
                            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                                {data.status === 'Leased' && <Button variant='outlined' size='small' startIcon={<ArticleIcon />} onClick={() => navigate('/agreements/' + agreement._id)}>Lease Agreement</Button>}
                                <LeaseHistory />
                                {data.status === 'Inactive' && <Button variant='outlined' sx={{ height: '40px' }} onClick={() => handleStatus('Active')}>Make Active</Button>}
                                {data.status === 'Active' && <Button variant='outlined' sx={{ height: '40px' }} onClick={() => handleStatus('Inactive')}>Make Inactive</Button>}
                            </Stack>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button variant='outlined' startIcon={<SaveIcon />} onClick={() => propertyEditRef.current?.submit()}>Save</Button>
                        </Box>
                    </Grid>
                </Grid>
            </PageContent>
        </PageShell>
    )
}

export function UpdateListing() {
    const { id } = useParams()
    const [data, setData] = useState({ images: [], documents: [] })
    const [refresh, setRefresh] = useState(false)
    // const [tenant, setTenant] = useState({})
    const [agreement, setAgreement] = useState({})
    const navigate = useNavigate()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const toggleRefresh = () => setRefresh(r => !r)

    useEffect(() => {
        toggleRefresh()
    }, [])

    useEffect(() => {
        (async () => {
            const result = await GetProperty(id)
            const { data } = result
            const { tenants, status } = data
            if (status === "Leased") {
                const currentTenant = tenants[tenants.length - 1]
                const { agreementId } = currentTenant
                const res = await GetAgreementById(agreementId)
                //const resp = await GetCompanyById(tenantId)
                setAgreement(res.data)
                //setTenant(resp.data)
            }
            setData(data)
        })()
    }, [refresh, id])

    const addDocument = (doc) => AddDocument(id, doc).then(toggleRefresh)
    const addRemark = (doc) => AddRemark(id, doc).then(toggleRefresh)
    const handleStatus = (status) => { UpdatePropertyStatus(id, { status }).then(toggleRefresh) }
    const handleSave = () => { /* Save logic handled by PropertyEditView */ }

    return <Box>
        <Box>
            <Button style={{ float: 'right' }} variant='outlined' onClick={() => navigate(-1)} startIcon={<BackIcon />}>Back</Button>
        </Box>
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <PropertyEditView listing={data} onRefresh={toggleRefresh} />
            </Grid>
            <Grid item xs={12} md={6}>
                <HeaderImageView listing={data} onRefresh={toggleRefresh} />
                <OtherImageView listing={data} onRefresh={toggleRefresh} />
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <Documents docIds={data.documents} onUpload={res => addDocument(res._id)} module="Property" />
                    <Remarks docIds={data.remarks} onUpload={res => addRemark(res._id)} fullWidth={true} module="Property" />
                </Box>
                <div className='mt-4'>
                    <Typography variant="h6" sx={{ mb: 1 }}>Lease Info</Typography>
                    <Divider sx={{ mb: 1 }} />
                    {data.status === 'Leased' ? (
                        <Fragment>
                            <Typography variant="body2" gutterBottom component="div">
                                Account: {agreement.title}
                            </Typography>
                            <Typography variant="body2" gutterBottom component="div">
                                Account Number#: {agreement.agreementNum}
                            </Typography>
                        </Fragment>
                    ) : <Typography variant="body2" gutterBottom component="div">
                        Status: {data.status}
                    </Typography>}

                    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        {data.status === 'Leased' && <Button variant='outlined' size='small' startIcon={<ArticleIcon />} onClick={() => navigate('/agreements/' + agreement._id)}>Lease Agreement</Button>}
                        <LeaseHistory />
                        {data.status === 'Inactive' && <Button variant='outlined' sx={{ height: '40px' }} onClick={() => handleStatus('Active')}>Make Active</Button>}
                        {data.status === 'Active' && <Button variant='outlined' sx={{ height: '40px' }} onClick={() => handleStatus('Inactive')}>Make Inactive</Button>}
                    </Stack>
                </div>
            </Grid>
        </Grid>
    </Box >
}

function HeaderImageView({ listing, onRefresh }) {

    const { id } = useParams()

    const handleUpload = (data) => {
        (async () => {
            await HeaderImage(id, data)
            onRefresh()
        })()
    }

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Header Image</Typography>
            {listing.headerImage
                ? <Box sx={{ mb: 1 }}>
                    <img alt='header' style={{ width: 120, height: 80, objectFit: 'cover', borderRadius: 8 }}
                        src={config.REACT_APP_API_URL + '/api/Property/List/Images/' + listing.headerImage} />
                  </Box>
                : <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>No image uploaded</Typography>
            }
            <ImageUpload onUpload={handleUpload} />
        </Box>
    )
}

function OtherImageView({ listing, onRefresh }) {
    const { id } = useParams()

    const handleUpload = (data) => {
        (async () => {
            await AddImages(id, data)
            onRefresh()
        })()
    }

    const handleDelete = (doc) => {
        (async () => {
            await RemoveImages(id, doc)
            onRefresh()
        })()
    }

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Display Images</Typography>
            {listing.images.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                    {listing.images.map(e => {
                        if (!e) return null
                        return (
                            <Box key={e} sx={{ position: 'relative', display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                <img alt='' style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 6 }}
                                    src={config.REACT_APP_API_URL + '/api/Property/List/Images/' + e} />
                                <Button size='small' color='error' onClick={() => handleDelete(e)} sx={{ minWidth: 0, px: 1, py: 0, fontSize: 11 }}>Delete</Button>
                            </Box>
                        )
                    })}
                </Box>
            )}
            <ImageUpload onUpload={handleUpload} />
        </Box>
    )
}

function ImageUpload({ onUpload }) {
    const fileRef = React.useRef()
    const cameraRef = React.useRef()
    const [anchor, setAnchor] = React.useState(null)

    const handleChange = (evt) => {
        const files = evt.target.files
        if (files && files.length > 0) {
            const file = files[0]
            if (file.size < 5000000) {
                const formData = new FormData()
                formData.append('file', file)
                onUpload(formData)
                evt.target.value = ''
            } else {
                if (DefaultSettings.getAlert() != null)
                    DefaultSettings.getAlert().show('File Size cannot be more than 5MB', 'error')
            }
        }
        setAnchor(null)
    }

    return (
        <>
            <input ref={fileRef} type='file' accept='image/*,image/heic' style={{ display: 'none' }} onChange={handleChange} />
            <input ref={cameraRef} type='file' accept='image/*' capture='environment' style={{ display: 'none' }} onChange={handleChange} />
            <input 
                type='button'
                value='Choose File'
                onClick={e => setAnchor(e.currentTarget)}
                style={{
                    padding: '6px 12px',
                    fontSize: '14px',
                    color: '#666',
                    cursor: 'pointer',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#fff'
                }}
            />
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
                <MenuItem onClick={() => { fileRef.current.click(); setAnchor(null); }}>
                    <ListItemIcon><UploadFileIcon fontSize='small' /></ListItemIcon>
                    <ListItemText>Upload from Device</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => { cameraRef.current.click(); setAnchor(null); }}>
                    <ListItemIcon><CameraAltIcon fontSize='small' /></ListItemIcon>
                    <ListItemText>Take Photo</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}
